import { useEffect } from "react"

import { useUserContext } from "../context/usercontext"

function MyPoints() {
  const { userData, refetchUserData } = useUserContext()
  useEffect(() => {
    const fetchData = async () => {
      if (userData) {
        await refetchUserData(userData)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="my-points-header">
      <h3 className="text-sm font-semibold m-0">Puntos disponibles:</h3>
      <hr />
      <span className="text-3xl font-bold">
        <i className="pi pi-wallet mr-2" />
        {userData?.points.toLocaleString("en-US")}
      </span>
    </div>
  )
}

export default MyPoints
